"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
// 车系弹窗组件
var react_1 = __importStar(require("react"));
var request_1 = require("../../utils/request");
var dataStorage_1 = require("../../utils/dataStorage");
var SidePullPop_1 = require("../SidePullPop");
var WithErrorHandler_1 = require("../WithErrorHandler");
var LineList = function (props) {
    var _a = __read(react_1.useState({}), 2), listData = _a[0], setListData = _a[1];
    var linesPop_list = react_1.useRef(null);
    react_1.useEffect(function () {
        if (props.show && ((props.brandId && props.brandId != -1) || props.getDataType == "data")) {
            if (linesPop_list && linesPop_list.current) {
                linesPop_list.current.scrollTop = 0;
            }
            setListData({});
            getLineData(props.brandId);
        }
    }, [props]);
    var getLineData = react_1.useCallback(function (brandId) {
        // 获取车系数据
        var ajaxUrl = props.ajaxUrl, saveKey = props.saveKey;
        if (props.getDataType === 'data') {
            // 从props.data中获取数据
            var data = props.data ? props.data : {};
            setListData(data);
        }
        else {
            dataStorage_1.getStorageData(saveKey + brandId).then(function (data) {
                // 本地有品牌数据
                // @ts-ignore
                setListData(data);
            }, function (error) {
                // 本地没有品牌数据 异步获取数据
                ajaxUrl &&
                    request_1.request(ajaxUrl, {
                        brandId: brandId
                    }, "jsonp")
                        .then(function (response) {
                        if (response.code == 0) {
                            var data = response.entity.data;
                            dataStorage_1.setStorageData({
                                key: saveKey + brandId,
                                value: data,
                                expire: 10
                            });
                            setListData(data);
                        }
                        else {
                            console.log(response.message);
                        }
                    })
                        .catch(function (error) {
                        console.log(error);
                    });
            });
        }
    }, [props]);
    var selectLine = react_1.useCallback(function (obj) {
        var callbackFun = props.callbackFun;
        obj.brandId = props.brandId;
        callbackFun && callbackFun(obj);
    }, [props.brandId, props.callbackFun]);
    return (react_1.default.createElement(SidePullPop_1.SidePullPop, { closeFun: props.closeFun, show: props.show, popId: "linesPop", title: "\u9009\u62E9\u8F66\u7CFB" },
        react_1.default.createElement("dl", { ref: linesPop_list, className: "newcar_ui_popList", id: "linesPop_list" },
            Object.keys(listData).length == 0 && (react_1.default.createElement("p", { className: "newcar_ui_empty" }, "\u6682\u65E0\u6570\u636E")),
            Object.keys(listData).map(function (key) { return (react_1.default.createElement(react_1.Fragment, { key: key },
                props.showSelectAll && (react_1.default.createElement("dd", null,
                    react_1.default.createElement("a", { className: "newcar_ui_name all-select", style: { borderTop: "1px solid #e6e6e6" }, onClick: function () { return selectLine({}); } }, "\u9009\u62E9\u5168\u90E8"))),
                listData[key].firmName && (react_1.default.createElement("dt", { className: "newcar_ui_subTitle" }, listData[key].firmName)),
                listData[key].lineArr.map(function (i, v) { return (react_1.default.createElement("dd", { key: i.lineId },
                    react_1.default.createElement("a", { className: "newcar_ui_name " + (i.lineId == props.lineId ? "cur" : ""), onClick: function () {
                            return selectLine(__assign(__assign({}, i), { firmId: listData[key].firmId }));
                        } },
                        react_1.default.createElement("span", { className: "newcar_ui_linePop_lineName" }, i.lineName),
                        props.showPrice && i.showPrice && react_1.default.createElement("span", { className: "newcar_ui_linePop_linePrice" }, i.showPrice)))); }))); }))));
};
LineList.defaultProps = {
    getDataType: "ajax",
    saveKey: "lineList",
    ajaxUrl: "//m.58che.com/home.php?c=ajax_LineList&a=Line&status=10,30,40",
    show: false,
    data: null,
    showPrice: false,
    // eslint-disable-next-line no-empty-function
    closeFun: function () { },
    // eslint-disable-next-line no-empty-function
    callbackFun: function (obj) { }
};
exports.default = WithErrorHandler_1.WithErrorHandler(react_1.memo(LineList));
